export const FETCH_USER_INFORMATION_SUCCESS =
  "user/FETCH_USER_INFORMATION_SUCCESS";
  
